/** Match the iOS 26 tab platter; Android uses the same geometry with ordinary frosting. */
export const FLOATING_TAB_BAR_HEIGHT_PX = 62;

/** UIKit's 83pt tab bar contains a 62pt platter above a 21pt lower gutter. */
export const FLOATING_TAB_BAR_BOTTOM_GAP_PX = 21;
